import React from 'react';
import {Modal, Table} from 'semantic-ui-react';

import {Section, Container} from './style';
import Dog from './../../assets/images/amigoo.svg';

const InfoPlan = () => {
  return (
    <Section>
      <Container>
        <img src={Dog} alt="Amigoo plan"/>

        <div className="content__article">
          <h1>Plano Recompensas</h1>
          <ul>
            <li>
              <span className={'roxo'}>
                <i className="material-icons">attach_money</i>
              </span>
              Limite total de R$500,00 durante a vigência do plano.
            </li>
            <li>
              <span className={'amarelo'}>
                <i className="material-icons">cake</i>
              </span>
              Contratação para pets com até 7 anos, 11 meses e 30 dias.
            </li>
            <li>
              <span className={'verde'}>
                <i className="material-icons">event_available</i>
              </span>
              Doenças preexistentes, declaradas ou não, possuem carência de 12 meses.
            </li>
          </ul>

          <small>
            A vigência do plano acima é de livre escolha do contratante, podendo ser de 45, 75, 105, 195 ou 375 dias.<br/>
            A opção pelo período de vigência deve ser feita antes da contratação do plano no ambiente de recompensas do programa de benefício do contratante.<br/>
            O voucher gerado pelo programa de recompensas já vincula o período de vigência escolhido para o plano.
          </small>

          <Modal trigger={<button className={'button__price'}>Tabela de serviços</button>} dimmer={'inverted'} size={'small'}>
            <Modal.Header>Plano Recompensas</Modal.Header>
            <Modal.Content>
              <Table celled inverted>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Serviços emergenciais para acidentes e enfermidades</Table.HeaderCell>
                    <Table.HeaderCell>Limite por evento</Table.HeaderCell>
                    <Table.HeaderCell>Carências</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Consulta emergencial</Table.Cell>
                    <Table.Cell textAlign={'center'}>Até R$100,00</Table.Cell>
                    <Table.Cell textAlign={'center'}>15 dias</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Atendimento ambulatorial</Table.Cell>
                    <Table.Cell textAlign={'center'}>Até R$150,00</Table.Cell>
                    <Table.Cell textAlign={'center'}>15 dias</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Assistência Funeral</Table.Cell>
                    <Table.Cell textAlign={'center'}>Até R$250,00</Table.Cell>
                    <Table.Cell textAlign={'center'}>15 dias</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Modal.Content>
          </Modal>
        </div>
      </Container>
    </Section>
  )
};

export default InfoPlan;